<template>
    <div class="my-order">
        <!-- 选项卡 -->
        <div class="flex__around__center nav">
            <div class="flex align-center nav__item" :class="loads.index==index?'active':''" v-for="(item,index) in nav_list" :key="index" @click="link('/Mall/MyOrder?index='+index,index)">
                <span class="fs_30" :class="loads.index==index?'c_1a fw_500':'c_66'">{{item.text}}</span>
            </div>
        </div>
        <div class="list">
            <div class="list__item" v-for="item in list" :key="item.id">
                <div class="flex__between list__item__header">
                    <span class="fs_26 c_66">交易单号：{{item.order_number}}</span>
                    <span class="fs_28" :class="item.status==1||item.status==2||item.status==3||item.status==4||item.status==6?'c_main':'c_b3'">{{item.status_name}}</span>
                </div>
                <div class="item-box" v-link="'/Mall/OrderDetail?id='+item.id">
                    <div class="flex item" v-for="(item1,index1) in item.order_product" :key="index1">
                        <img :src="item1.product_cover_img" alt="">
                        <div class="flex__null__around item__right">
                            <span class="fs_26 c_1a lh_36 ellipsis_two">{{item1.product_name}}</span>
                            <span class="fs_22 c_98" v-if="item1.product_sku_name">规格: {{item1.product_sku_name}}</span>
                            <div class="flex__between">
                                <span class="fs_30 c_main"><span class="fs_22">¥</span>{{item1.product_price}}</span>
                                <span class="fs_26 c_80">x{{item1.number}}</span>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="list__item__footer">
                    <div class="flex__end__center list__item__footer__top">
                        <span class="fs_24 c_4d">共{{item.product_count}}件商品&emsp;合计：</span>
                        <span class="fs_30 c_main"><span class="fs_22">¥</span>{{item.total_price}}</span>
                    </div>
                    <div class="flex__end__center list__item__footer__bottom" v-if="item.status!=6">
                        <button class="hollow-btn" v-if="item.status==1" @click="cancel(item.id)">取消订单</button>
                        <button class="hollow-btn" v-if="item.status==4||item.status==5||item.status==7||item.status==8" @click="del(item.id)">删除订单</button>
                        <button class="hollow-btn" v-if="item.status==3||item.status==4||item.status==5" @click="setLogistics(item.id)">查看物流</button>
                        <button class="hollow-btn" v-if="item.status==2" @click="refund(item.id)">申请退款</button>
                        <button class="solid-btn" v-if="item.status==4" v-link="'/Mall/Evaluate/'+item.id">评价</button>
                        <button class="solid-btn" v-if="item.status==3" @click="harvest(item.id)">确认收货</button>
                        <button class="solid-btn" v-if="item.status==1" @click="pay(item.id)">支付</button>
                        <button class="solid-btn" v-if="item.status==2" @click="remind(item.id)">提醒发货</button>
                    </div>
                </div>
            </div>
        </div>
        <jc-list v-if="refresh" :url="'/Mall/getMyOrderList'" :loads="loads" @load='getList'></jc-list>
    </div>
</template>
<script>
export default {
    name:"MyOrder",
    data(){
        return{
            refresh: true, //刷新组件用
            list: [],
            loads:{
                user_id: localStorage.user_id,
                index: 0
            },
            nav_list:[
                {text:'全部',status: 0},
                {text:'待支付',status: 1},
                {text:'待发货',status: 2},
                {text:'待收货',status: 3},
                {text:'待评价',status: 4}
            ] 
        }
    },
    methods:{
        getList (data) { 
            this.list=data;
        },
        link(url,index){
            this.$router.push(url);
            this.loads.index=index;
        },
        // 提醒发货
        remind(id){
            this.axios.post('/wechat.php/Mall/submitRemind',{
                user_id: localStorage.user_id,
                order_id: id
            }).then(
                res=>{
                    this.$dialog.alert({
                        message: res.data.message
                    })
                }
            )
        },
        // 取消订单
        cancel(id){
            this.refresh=false;
            this.$dialog.confirm({
                message: '确认取消该订单？'
            }).then(() => {
                this.axios.post('/wechat.php/Mall/cancelOrder',{
                    user_id: localStorage.user_id,
                    order_id: id
                }).then(
                    res=>{
                        this.refresh=true;
                        this.$dialog.alert({
                            message: res.data.message
                        })
                    }
                )
            }).catch(()=>{})
        },
        // 申请退款
        refund(id){
            this.refresh=false;
            this.$dialog.confirm({
                message: '确认申请退款该订单？'
            }).then(() => {
                this.axios.post('/wechat.php/Mall/submitRefund',{
                    user_id: localStorage.user_id,
                    order_id: id
                }).then(
                    res=>{
                        this.refresh=true;
                        this.$dialog.alert({
                            message: res.data.message
                        })
                    }
                )
            }).catch(()=>{})
        },
        // 删除订单
        del(id){
            this.refresh=false;
            this.$dialog.confirm({
                message: '确认删除该订单？'
            }).then(() => {
                this.axios.post('/wechat.php/Mall/submitDeleteOrder',{
                    user_id: localStorage.user_id,
                    order_id: id
                }).then(
                    res=>{
                        this.refresh=true;
                        this.$dialog.alert({
                            message: res.data.message
                        })
                    }
                ) 
            }).catch(()=>{})
        },
        // 查看物流
        setLogistics(id){
            this.$store.commit('setLogistics','/wechat.php/Mall/getExpressData');
            this.$router.push('/Mall/Logistics/'+id);
        },
        // 确认收货
        harvest(id){
            this.refresh=false;
            this.$dialog.confirm({
                message: '确认收货？'
            }).then(() => {
                this.axios.post('/wechat.php/Mall/confirmOrder',{
                    user_id: localStorage.user_id,
                    order_id: id
                }).then(
                    res=>{
                        this.refresh=true;
                        this.$dialog.alert({
                            message: res.data.message
                        })
                    }
                )
            }).catch(()=>{})
        },
        // 支付
        pay(id){
            this.refresh=false;
            this.axios.post('/wechat.php/Mall/payOrder',{
                user_id:localStorage.user_id,
                order_id:id,
            }).then(
                res=>{
                    if(res.data.code==1){
                        this.$wx.wxPay(res.data.data.pay_parameters).then(()=>{
                            this.refresh=true;
                        });
                    }else{
                        this.$dialog.alert({
                            message: res.data.message
                        })
                    }
                }
            )
        }
    },
    mounted(){
        this.loads.index=this.$route.query.index;
    }
}
</script>
<style scoped>
.nav{
    position: fixed;
    top: 0;
    width: 100%;
    height: 90px;
    z-index: 1;
    background: #fff;
}
.nav__item.active{
    height: 90px;
    border-bottom: 4px solid #F93A42;
}
.list{
    padding: 90px 20px 0;
}
.list__item{
    margin-top: 15px;
    padding: 30px 20px 0;
    background: #fff;
    border-radius:10px;
}
.item-box{
    padding: 15px 0 30px; 
    border-bottom: 2px solid #e6e6e6;
}
.item{
    margin-top: 30px;
}
.item:last-child{
    border: 0;
}
.item img{
    width: 180px;
    height: 180px;
    border-radius: 10px;
}
.item__right{
    width: 460px;
    margin-left: 30px;
}
.list__item__footer__top{
    height: 90px;
}
.list__item__footer__bottom{
    padding-bottom: 30px;
}
.list__item button{
    width: 160px;
    height: 55px;
    line-height: 55px;
    border-radius:30px;
    margin-left: 10px;
}
.list__item .hollow-btn{
    background: none;
    border: 2px solid #e6e6e6;
    font-size: 26px;
    color: #808080;
}
.list__item .solid-btn{
    background: #F93A42;
    font-size: 26px;
    color: #fff;
}
</style>





// WEBPACK FOOTER //
// src/pages/mall/MyOrder.vue